<template>
    <div v-if="selectedMenu == 'mySessions'">
        <my-sessions @modifySettingsSelectedMenu="modifySettingsSelectedMenu"></my-sessions>
    </div>
    <div v-else>
        <div class="row pt-2 user-settings-block">
            <div class="col-12 mt-4 p-lr-0-sm">
                <div class="fast-actions-block p-3">
                    <div class="content-crds-messages-scroll">
                        <div class="dis-flex flex-column">
                            <button type="button" class="btn btn-element mb-3" @click="selectedMenu = 'mySessions'"><i class="uis uis-channel mr-3 text-blue fs-16"></i>Sessions<i class="uis uis-angle-double-right fs-16 ml-auto text-blue"></i></button>
                            <button type="button" class="btn btn-element mb-3"><i class="uis uis-comment-info-alt mr-3 text-blue fs-16"></i>Notifications<i class="uis uis-angle-double-right fs-16 ml-auto text-blue"></i></button>
                            <button type="button" class="btn btn-element mb-3"><i class="uis uis-palette mr-3 text-blue fs-16"></i>Appearance<i class="uis uis-angle-double-right fs-16 ml-auto text-blue"></i></button>
                            <button type="button" class="btn btn-element mb-3"><i class="uis uis-english-to-chinese mr-3 text-blue fs-16"></i>System Language<i class="uis uis-angle-double-right fs-16 ml-auto text-blue"></i></button>
                            <button type="button" class="btn btn-element mb-3"><i class="uis uis-file-question-alt mr-3 text-blue fs-16"></i>Help<i class="uis uis-angle-double-right fs-16 ml-auto text-blue"></i></button>
                            <button type="button" class="btn btn-element"><i class="uis uis-cloud-info mr-3 text-blue fs-16"></i>About System<i class="uis uis-angle-double-right fs-16 ml-auto text-blue"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mySessionsVue from "./mySettings/mySessions.vue"

export default {
    components: {
        mySessions: mySessionsVue
    },
    data() {
        return {
            selectedMenu: null
        }
    },
    methods: {
        modifySettingsSelectedMenu(selectedMenu) {
            this.selectedMenu = selectedMenu
        }
    }
}
</script>

<style>

</style>